import { NgRedux, select } from '@angular-redux/store';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NboEmobilityCalculateRequest } from '@api-cc';
import { getTranslationCaption, WHERE_TO_INSTALL_CHARGER_MORE_THAN_60 } from '@theia-cc/em/core';
import {
  EmStateAction,
  IAppStateEm,
  TranslationPropertyEm,
  genericTranslationSelector,
} from '@theia-cc/em/state';
import { ILanguageSpecificStringWithType } from '@theia-cc/shared/models';
import { IChoiceButton } from '@theia-cc/shared/step-ui';
import { SharedStoreEffect, languageSelector } from '@theia-cc/shared/store';
import { Observable, map } from 'rxjs';

const translationProperty: TranslationPropertyEm = 'whereToInstallCharger';

@Component({
  selector: 'app-where-to-install-charger',
  templateUrl: './where-to-install-charger.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class WhereToInstallChargerComponent implements OnInit {
  public whereToInstallChargerSelection: string;
  whereToInstallChargerItems$: Observable<IChoiceButton[]>;

  @select((store: IAppStateEm) => genericTranslationSelector(store, translationProperty, 'title'))
  title$: Observable<ILanguageSpecificStringWithType>;

  @select((store: IAppStateEm) =>
    genericTranslationSelector(store, translationProperty, 'subtitle')
  )
  subtitle$: Observable<ILanguageSpecificStringWithType>;

  @select(languageSelector)
  readonly currentLanguage$: Observable<string>;

  constructor(
    private router: Router,
    private effect: SharedStoreEffect,
    private stepActions: EmStateAction,
    private store: NgRedux<IAppStateEm>
  ) {}

  ngOnInit(): void {
    this.effect.setNavbarDefaultEmpty();

    const appState: IAppStateEm = this.store.getState();

    this.whereToInstallChargerItems$ = this.currentLanguage$.pipe(
      map(currentLanguage => this.initOptions(appState, currentLanguage))
    );

    const { whereToInstallCharger } = appState.collectedData;
    this.whereToInstallChargerSelection = whereToInstallCharger;
  }

  saveStepData(value: string): void {
    this.stepActions.storeWhereToInstallCharger(value);

    if (value === WHERE_TO_INSTALL_CHARGER_MORE_THAN_60) {
      this.navigateToContactFormStep();
    } else {
      this.effect.navigateNext();
    }
  }

  private initOptions(appState: IAppStateEm, currentLanguage: string): IChoiceButton[] {
    return [
      {
        value: NboEmobilityCalculateRequest.WhereToInstallChargerEnum.IndividualSolution,
        icon: false,
        type: 'medium',
        caption: getTranslationCaption(
          appState,
          translationProperty,
          'optionIndividualSolution',
          currentLanguage
        ),
      },
      {
        value: NboEmobilityCalculateRequest.WhereToInstallChargerEnum.CommunitySolution,
        icon: false,
        type: 'medium',
        caption: getTranslationCaption(
          appState,
          translationProperty,
          'optionCommunitySolution',
          currentLanguage
        ),
      },
      {
        value: WHERE_TO_INSTALL_CHARGER_MORE_THAN_60,
        icon: false,
        type: 'medium',
        caption: getTranslationCaption(
          appState,
          translationProperty,
          'optionMoreThan60',
          currentLanguage
        ),
      },
    ];
  }

  private navigateToContactFormStep(): void {
    this.router
      .navigate(['/contact'], {
        queryParamsHandling: 'preserve',
      })
      .catch(error => console.log(error));
  }
}
